import { render, staticRenderFns } from "./DoubleOptIn.vue?vue&type=template&id=f37e0a24&"
import script from "./DoubleOptIn.vue?vue&type=script&lang=ts&"
export * from "./DoubleOptIn.vue?vue&type=script&lang=ts&"
import style0 from "./DoubleOptIn.vue?vue&type=style&index=0&id=f37e0a24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports